import {RootState} from '../rootReducer';
import {createSelector} from '@reduxjs/toolkit';

export const patientAdminStatus = createSelector(
  [(state: RootState) => state.patientAdmin.isLoading],
  isLoading => isLoading,
);

export const patientAccountTicketLoadingSelector = createSelector(
  [(state: RootState) => state.patientAdmin.patientAccountTicketLoading],
  patientAccountTicketLoading => patientAccountTicketLoading ?? false,
);

export const patientAdminSuccessSelector = createSelector(
  [(state: RootState) => state.patientAdmin.patientAdminSuccess],
  patientAdminSuccess => patientAdminSuccess,
);

export const patientAdminFailureSelector = createSelector(
  [(state: RootState) => state.patientAdmin.patientAdminFailure],
  patientAdminFailure => patientAdminFailure,
);

export const categoryDataSelector = createSelector(
  [(state: RootState) => state.patientAdmin.categoryManagement.categories],
  categories => categories || [],
);

export const categoryCurrentPageSelector = createSelector(
  [(state: RootState) => state.patientAdmin.categoryManagement.currentPage],
  currentPage => currentPage,
);

export const categoryTotalPagesSelector = createSelector(
  [(state: RootState) => state.patientAdmin.categoryManagement.totalPages],
  totalPages => totalPages,
);

export const categoryTotalResultSelector = createSelector(
  [(state: RootState) => state.patientAdmin.categoryManagement.totalResults],
  totalResults => totalResults,
);

export const categoryNextPageSelector = createSelector(
  [(state: RootState) => state.patientAdmin.categoryManagement.nextPage],
  nextPage => nextPage,
);

// Filter Management Selectors
export const filterOptionsSelector = createSelector(
  [(state: RootState) => state.patientAdmin.filterManagement],
  filterManagement => filterManagement,
);

// Popular Specialist Management Selectors
export const popularSpecialistDataSelector = createSelector(
  [(state: RootState) => state.patientAdmin.popularSpecialistManagement?.specialists],
  specialists => specialists || [],
);

export const popularSpecialistCurrentPageSelector = createSelector(
  [(state: RootState) => state.patientAdmin.popularSpecialistManagement?.currentPage],
  currentPage => currentPage ?? 0,
);

export const popularSpecialistTotalPagesSelector = createSelector(
  [(state: RootState) => state.patientAdmin.popularSpecialistManagement?.totalPages],
  totalPages => totalPages ?? 0,
);

export const popularSpecialistTotalResultSelector = createSelector(
  [(state: RootState) => state.patientAdmin.popularSpecialistManagement?.totalResults],
  totalResults => totalResults ?? 0,
);

export const popularSpecialistNextPageSelector = createSelector(
  [(state: RootState) => state.patientAdmin.popularSpecialistManagement?.nextPage],
  nextPage => nextPage ?? null,
);



// ==============================================
// Patient Admin Dashboard Selectors
// ==============================================
export const patientAdminDashboardConsultationsSelector = createSelector(
  [(state: RootState) => state.patientAdmin.dashboard?.consultations],
  consultations => consultations || [],
);

export const patientAdminDashboardNextPageSelector = createSelector(
  [(state: RootState) => state.patientAdmin.dashboard?.next_page],
  nextPage => nextPage ?? null,
);

export const patientAdminDashboardCurrentPageSelector = createSelector(   
  [(state: RootState) => state.patientAdmin.dashboard?.current_page],
  currentPage => currentPage ?? 0,
);

export const patientAdminDashboardTotalPagesSelector = createSelector(
  [(state: RootState) => state.patientAdmin.dashboard?.total_pages],
  totalPages => totalPages ?? 0,
);

export const patientAdminDashboardTotalResultsSelector = createSelector(
  [(state: RootState) => state.patientAdmin.dashboard?.total_results],
  totalResults => totalResults ?? 0,
);

// ==============================================
// Popularity Limit Selector
// ==============================================
export const popularityLimitSelector = createSelector(
  [(state: RootState) => state.patientAdmin.popularityLimit],
  limit => limit ?? null,
);

// ==============================================
// Patient Account Tickets Selectors
// ==============================================
export const patientAccountTicketsSelector = createSelector(
  [(state: RootState) => state.patientAdmin.patientAccountTickets?.tickets],
  tickets => tickets || [],
);

export const patientAccountTicketsNextPageSelector = createSelector(
  [(state: RootState) => state.patientAdmin.patientAccountTickets?.next_page],
  nextPage => nextPage ?? null,
);

export const patientAccountTicketsCurrentPageSelector = createSelector(
  [(state: RootState) => state.patientAdmin.patientAccountTickets?.current_page],
  currentPage => currentPage ?? 0,
);

export const patientAccountTicketsTotalPagesSelector = createSelector(
  [(state: RootState) => state.patientAdmin.patientAccountTickets?.total_pages],
  totalPages => totalPages ?? 0,
);

export const patientAccountTicketsTotalResultsSelector = createSelector(
  [(state: RootState) => state.patientAdmin.patientAccountTickets?.total_results],
  totalResults => totalResults ?? 0,
);

// ==============================================
// Hospital Details Selectors
// ==============================================
export const hospitalDetailsSelector = createSelector(
  [(state: RootState) => state.patientDashboard?.hospitalDetails?.data],
  hospitalDetails => hospitalDetails ?? null,
);

export const hospitalDetailsLoadingSelector = createSelector(
  [(state: RootState) => state.patientDashboard?.hospitalDetails?.isLoading],
  isLoading => isLoading ?? false,
);